import GeoModerationPage from './GeoModerationPage';
import { useRestaurants, useBulkRestaurants } from '../../hooks/useRestaurants';

const config = {
  title: 'Restaurant Moderation',
  singular: 'Restaurant',
  useList: useRestaurants,
  useBulk: useBulkRestaurants,
};

export default function RestaurantModerationPage() {
  return <GeoModerationPage config={config} />;
}
